import { ISearchItem } from 'models/ISearchItem';
import { SuggestedPhrase } from 'models/SuggestedPhrase';

interface ConcreteSearchItem extends ISearchItem {
  url: string;
}

export const isConcreteSearchItem = (searchItem?: ISearchItem): searchItem is ConcreteSearchItem =>
  searchItem !== undefined && (searchItem as ConcreteSearchItem).url !== undefined;

export const isSearchPhrase = (searchItem?: ISearchItem): searchItem is SuggestedPhrase =>
  searchItem !== undefined && (searchItem as SuggestedPhrase).phrase !== undefined;
